import { useEffect } from "react";

/**
 * Custom hook to prevent body scrolling when lightbox is open
 * Automatically restores scroll on unmount
 */
export function useBodyScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (isLocked) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isLocked]);
}
